import React, { useState } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { AccountsTypeElementField } from "@/features/home/components/accounts-type-element-field";
import { SelectInstitutionsModal } from "@/features/institutions/components/select-institutions-modal";
import { SelectInstitutionsServiceModal } from "@/features/institutions/components/select-institutions-service-modal";
import { InstitutionsAuthorizationModal } from "@/features/institutions/components/institutions-authorization-modal";
import { AddOcrAccountsModal } from "@/features/accounts/ocr/components/add-ocraccounts-modal";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { InstitutionsType } from "@/shared/config/globals"
import { PaymentLoginInfoModal } from "@/features/accounts/payment/scraping/components/payment-login-info-modal";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { OneTimePassProvider } from "@/features/accounts/payment/scraping/contexts/one-time-pass-context";
import { RegisterExcelAccountModal } from "@/features/accounts/csv-excel/components/register-excel-account-modal";
import { UploadCsvExcelModal } from "@/features/accounts/csv-excel/components/upload-csv-excel-modal";
import { usePostCsvExcelAccountsStates } from "@/features/accounts/csv-excel/hooks/use-import-trades-state";
import { RegisterCsvAccountModal } from "@/features/accounts/csv-excel/components/register-csv-account-modal";
import { usePaymentContext } from "@/features/accounts/payment/scraping/contexts/payment-context"
import { SelectAggregateTypeModal } from "@/features/accounts/ocr/components/select-aggregate-type-modal";
import { FileAggregateModal } from "@/features/accounts/ocr/components/file-aggregate-modal";
import { CameraAggregateModal } from "@/features/accounts/ocr/components/camera-aggregate-modal";
import { SelectCsvInstitutionModal } from "@/features/accounts/csv-excel/components/select-csv-institution-modal";
import { DownloadExcelTemplateModal } from "@/features/accounts/csv-excel/components/download-excel-template-modal";


interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: (paymentAccountId?: string) => void;
}

// 追加口座タイプ選択モーダル
export const AddNewAccountsModal= ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  // OCR口座のID保持用
  const [passbookName, setPassbookName] = useState<string | undefined>(undefined);
  const [ocrAccountId, setOcrAccountId] = useState<string | undefined>(undefined);
  const { csvExcelAccountId, setCsvExcelAccountId } = usePostCsvExcelAccountsStates();

  const {
    setInstitutionType,
  } = useInstitutionsContext();
  const {
    openHomeModal,
    setOpenHomeModal,
  } = useModalContext();
  const {
    setProcessType,
  } = usePaymentContext();

  return (
    <>
    { openHomeModal === "AddNewAccounts" && (
      <BasePageModal
        title="Web明細帳を作成"
        handleClose={() => {
          onTapCloseModal();
        }}
        className="md-add-list"
        disableOverlayClose={true}
      >
        <h2>
          Web明細帳の種類を選択する
        </h2>
        <ul>
          <AccountsTypeElementField
            title="銀行"
            handleClick={() => {
              setInstitutionType(InstitutionsType.Bank);
              setOpenHomeModal("SelectInstitutions");
            }}
            className="btn-bank"
          />
          <AccountsTypeElementField
            title="クレジットカード"
            handleClick={() => {
              setInstitutionType(InstitutionsType.Card);
              setOpenHomeModal("SelectInstitutions");
            }}
            className="btn-card"
          />
          <AccountsTypeElementField
            title="電子マネー"
            handleClick={() => {
              setInstitutionType(InstitutionsType.ElectronicMoney);
              setOpenHomeModal("SelectInstitutions");
            }}
            className="btn-emoney"
          />
          <AccountsTypeElementField
            title="他サービス連携"
            handleClick={() => {
              setInstitutionType(InstitutionsType.Other);
              setOpenHomeModal("SelectInstitutions");
            }}
            className="btn-app"
          />
          <AccountsTypeElementField
            title="通帳OCR"
            handleClick={() => {
              setOpenHomeModal("OcrAccount");
            }}
            className="btn-ocr"
          />
          <AccountsTypeElementField
            title="Excelファイル"
            handleClick={() => {
              setOpenHomeModal("RegisterExcelAccount");
            }}
            className="btn-excel"
          />
          <AccountsTypeElementField
            title="CSVファイル"
            handleClick={() => {
              setOpenHomeModal("SelectCsvInstitution");
            }}
            className="btn-excel"
          />
        </ul>
      </BasePageModal>
    )}

    { openHomeModal === "OcrAccount"
      &&(
      <AddOcrAccountsModal
        onTapCloseModal={() => {
          onTapCloseModal();
        }}
        onTapAddNextModal={(ocrAccountId) => {
          setOcrAccountId(ocrAccountId);
          setOpenHomeModal("SelectOcrAggregateType");
        }}
      />
    )}

    { openHomeModal === "SelectOcrAggregateType"
      &&(
      <SelectAggregateTypeModal
        onTapCompleteModal={() => {
          setOcrAccountId(undefined);
          onTapCompleteModal();
        }}
        onTapFileAggregate={() => {
          setOpenHomeModal("OcrFileAggregate");
        }}
        onTapCameraAggregate={() => {
          setOpenHomeModal("OcrCameraAggregate");
        }}
      />
    )}

    {/* ↓↓口座選択後の画像アップロード時のマウントを防ぐため，別のopenHomeModalを使用↓↓ */}
    { openHomeModal === "OcrFileAggregate"
      &&(
      <FileAggregateModal
        onTapCloseModal={() => {
          onTapCloseModal();
        }}
        onTapCompleteModal={() => {
          setOcrAccountId(undefined);
          onTapCompleteModal();
        }}
        ocrAccountId={ocrAccountId}
      />
    )}

    {openHomeModal === "OcrCameraAggregate" && (
      <CameraAggregateModal
        ocrAccountId={ocrAccountId}
        onTapCloseModal={() => {
          onTapCloseModal();
        }}
        onTapCompleteModal={() => {
          setOcrAccountId(undefined);
          onTapCompleteModal();
        }}
      />
    )}
    {/* ↑↑口座選択後の画像アップロード時のマウントを防ぐため，別のopenHomeModalを使用↑↑ */}

    {(openHomeModal === "SelectInstitutions") && (
      <SelectInstitutionsModal
        onTapCloseModal={() => {
          onTapCloseModal();
        }}
        onSelectInstitution={() => {
          setOpenHomeModal("Service");
        }}
      />
    )}

    { openHomeModal === "Service"
      && (
      <SelectInstitutionsServiceModal
        onTapCloseModal={() => {
          onTapCloseModal();
        }}
      />
    )}

    { openHomeModal === "SiteAuth" && (
      <InstitutionsAuthorizationModal
        onTapCloseModal={() => {
          onTapCloseModal();
        }}
      />
    )}

    <PaymentLoginInfoModal
      onTapCloseModal={() => {
        setProcessType("");
        onTapCloseModal();
      }}
      onTapCompleteModal={(paymentAccountId) => {
        onTapCompleteModal(paymentAccountId);
      }}
    />

    { openHomeModal === "SelectCsvInstitution"
      &&(
      <SelectCsvInstitutionModal
        onCloseModal={onTapCloseModal}
      />
    )}
    { openHomeModal === "RegisterCsvAccount"
      &&(
      <RegisterCsvAccountModal
        onCloseModal={onTapCloseModal}
        onCompleteModal={(csvExcelAccountId) => {
          setCsvExcelAccountId(csvExcelAccountId);
        }}
      />
    )}
    { openHomeModal === "RegisterExcelAccount"
      &&(
      <RegisterExcelAccountModal
        onCloseModal={onTapCloseModal}
        onCompleteModal={(csvExcelAccountId, passbookName) => {
          setCsvExcelAccountId(csvExcelAccountId);
          setPassbookName(passbookName);
        }}
      />
    )}
    { openHomeModal === "DownloadExcelTemplate"
      &&(
      <DownloadExcelTemplateModal
        csvExcelAccountId={csvExcelAccountId!}
        onCloseModal={onTapCloseModal}
        onCompleteModal={() => setOpenHomeModal("FirstUploadExcel")}
      />
    )}
    {(openHomeModal === "FirstUploadCsv" || openHomeModal === "FirstUploadExcel")
      &&(
      <UploadCsvExcelModal
        csvExcelAccountId={csvExcelAccountId}
        passbookName={passbookName}
        onCloseModal={onTapCompleteModal}  // 口座登録完了後のモーダルはスキップもあるため、完了と同じ処理をする
        onCompleteModal={onTapCompleteModal}
      />
    )}
    </>
  );
};
